export function userReducer(state = null, action) {
  switch (action.type) {
    case "LOGIN":
      return action.payload;

    case "REFRESH_TOKEN":
      return state ? { ...state, token: action.payload.token } : state;

    case "LOGOUT":
      return action.payload;
    default:
      return state;
  }
}
